import { createElement } from 'react';
import './index.scss';
const HhPanel = ({ title, content, flex = 1, children, ...otherProps }) => {
    const _otherProps = otherProps || {};
    _otherProps.style = otherProps.style || {};
    _otherProps.style.flex = flex;
    return (createElement("div", { className: 'panel', ...otherProps },
        createElement("div", { className: 'title' }, title || 'Panel标题'),
        createElement("div", { className: 'content' }, content || 'Panel内容')));
};
HhPanel.displayName = 'HhPanel';
export default HhPanel;
